/**
 * @flow
 * @relayHash e9685d06a5032e17f4d9dcd50c115839
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlockDeleteInput = {
  id: string,
  clientMutationId?: ?string,
};
export type BlockDeleteMutationVariables = {|
  input: BlockDeleteInput
|};
export type BlockDeleteMutationResponse = {|
  +BlockDelete: ?{|
    +error: ?string
  |}
|};
export type BlockDeleteMutation = {|
  variables: BlockDeleteMutationVariables,
  response: BlockDeleteMutationResponse,
|};
*/


/*
mutation BlockDeleteMutation(
  $input: BlockDeleteInput!
) {
  BlockDelete(input: $input) {
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "BlockDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "BlockDelete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "BlockDeleteInput!"
      }
    ],
    "concreteType": "BlockDeletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BlockDeleteMutation",
  "id": null,
  "text": "mutation BlockDeleteMutation(\n  $input: BlockDeleteInput!\n) {\n  BlockDelete(input: $input) {\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlockDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "BlockDeleteMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba8c44071402961c80858a76adf11f14';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/BlockDeleteMutation.graphql.js